import React from "react";
import { CollectionCarousel } from "../../index.js";
// import { moreInThisCollectionCarouselImpression } from "./analytics/impression";

export default function LatestCollectionCarousel(_ref) {
  var ProductCardsInfo = _ref.ProductCardsInfo,
    mobileSlidesToShow = _ref.mobileSlidesToShow,
    desktopSlidesToShow = _ref.desktopSlidesToShow,
    mobileWidth = _ref.mobileWidth,
    desktopWidth = _ref.desktopWidth,
    heading = _ref.heading,
    collection = _ref.collection,
    gutter = _ref.gutter,
    isMobile = _ref.isMobile;
  return /*#__PURE__*/React.createElement(CollectionCarousel, {
    ProductCardsInfo: ProductCardsInfo,
    mobileSlidesToShow: mobileSlidesToShow,
    desktopSlidesToShow: desktopSlidesToShow,
    mobileWidth: mobileWidth,
    desktopWidth: desktopWidth,
    heading: heading,
    collection: collection,
    gutter: gutter,
    isMobile: isMobile
  });
}